import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "ninjavity_cart";
export const FREE_SHIP = 60;
export const SHIP_COST = 4.9;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.code === product.code);
      if (ex) return prev.map((i) => (i.code === product.code ? { ...i, qty: i.qty + qty } : i));
      return [...prev, { code: product.code, name: product.name, brand: product.brand, price: product.price, img: product.img, qty }];
    });
  }, []);
  const setQty = useCallback((code, qty) => {
    setItems((prev) => (qty <= 0 ? prev.filter((i) => i.code !== code) : prev.map((i) => (i.code === code ? { ...i, qty } : i))));
  }, []);
  const remove = useCallback((code) => setItems((prev) => prev.filter((i) => i.code !== code)), []);
  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(() => {
    const count = items.reduce((s, i) => s + i.qty, 0);
    const subtotal = items.reduce((s, i) => s + i.qty * i.price, 0);
    const shipping = subtotal === 0 || subtotal >= FREE_SHIP ? 0 : SHIP_COST;
    return { items, count, subtotal, shipping, total: subtotal + shipping, add, setQty, remove, clear, open, setOpen };
  }, [items, add, setQty, remove, clear, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
